import type { ImageSizeTypeEnum, ImageTypeNameEnum } from '@inter-ikea-kompis/enums'

import type { EnumToStringUnion, ProductData } from '@sofa-platform/types'

export type ImageSize = EnumToStringUnion<typeof ImageSizeTypeEnum>
export type ImageTypeName = 'Non-Standardized Product Picture' | EnumToStringUnion<typeof ImageTypeNameEnum>

export function getProductImage(productData: ProductData, size: ImageSize, typeName: ImageTypeName) {
  const img = productData.content.image?.find((img) => img.size === size && img.typeName === typeName)
  return { alt: img?.alternativeText, src: img?.url }
}
